import React from "react";
import { Check } from "lucide-react";

export const STEP_LABELS = [
  "Business info",
  "Business type",
  "Services",
  "Hours",
  "Photos",
  "Preview",
  "Review",
  "Payment",
];

/**
 * Wizard progress: a continuous emerald bar with step pips above.
 * step is 1-based index (1..8 for the in-flow steps).
 */
export function WizardProgress({ step }) {
  const total = STEP_LABELS.length;
  const pct = Math.max(0, Math.min(100, ((step - 1) / (total - 1)) * 100));
  return (
    <div className="w-full" data-testid="wizard-progress">
      <div className="flex items-center justify-between mb-3 px-0.5">
        <div className="text-xs font-medium text-slate-500 uppercase tracking-wider">
          Step {step} of {total}
        </div>
        <div className="text-xs font-medium text-slate-700">
          {STEP_LABELS[step - 1]}
        </div>
      </div>
      <div className="relative h-1.5 bg-slate-100 rounded-full overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-blue-500 via-green-500 to-amber-400 rounded-full transition-all duration-500"
          style={{ width: `${pct}%` }}
        />
      </div>
      <div className="hidden sm:flex justify-between mt-3">
        {STEP_LABELS.map((label, i) => {
          const idx = i + 1;
          const done = idx < step;
          const active = idx === step;
          return (
            <div key={label} className="flex flex-col items-center gap-1 flex-1 min-w-0">
              <div
                className={`w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-semibold transition-all ${
                  done
                    ? "bg-emerald-500 text-white"
                    : active
                    ? "bg-slate-900 text-white ring-4 ring-slate-900/10"
                    : "bg-slate-200 text-slate-500"
                }`}
              >
                {done ? <Check className="w-3 h-3" /> : idx}
              </div>
              <span className={`text-[10px] truncate max-w-full ${active ? "text-slate-900 font-medium" : "text-slate-400"}`}>
                {label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
